module.exports = __webpack_public_path__ + "img/doctor-computer-PHONE.1ce9e4cb.jpg";